<template>
  <article class="support">
    <TextBanner columns="col--lg-8 col--md-10">
      <h1>Embed a Campsite Feature</h1>
      <p>See a demo of an embedded Campsite.</p>
    </TextBanner>

    <div class="grid grid--container support__inner">
      <div class="row row--md-h-center">
        <div class="col col--lg-8 col--md-10">
          <p>
            Do you want a link list landing page for Instagram, Facebook, TikTok
            or Twitter, but want to keep it on your own website? Get all the
            power of Campsite on your own website by embedding your Campsite
            profile with our powerful embed feature! Take a look at the Campsite
            profile embedded directly into this page below.
          </p>
          <!-- Start Campsite embed code -->
          <iframe
            id="js-campsite-iframe"
            src="https://campsite.bio/camper_embed?iframe=1"
            frameborder="0"
            scrolling="no"
            width="100%"
            height="500"
          ></iframe>
          <!-- End Campsite embed code -->
          <p>Here is an example of what the embed code looks like:</p>
          <Code
            >&lt;!-- Start Campsite embed code --&gt; &lt;iframe
            id=&quot;js-campsite-iframe&quot;
            src=&quot;https://campsite.bio/my-campsite-username?iframe=1&quot;
            frameborder=&quot;0&quot; scrolling=&quot;no&quot;
            width=&quot;100%&quot; height=&quot;500&quot;&gt;&lt;/iframe&gt;
            &lt;script src=&quot;{{ cdnHost }}/js/iframe.js&quot;
            async&gt;&lt;/script&gt; &lt;!-- End Campsite embed code
            --&gt;</Code
          >
          <p>
            <em
              >This is just an example of an embed code and will not work on any
              other site.</em
            >
          </p>
          <h2 class="h3">Already have a Campsite account?</h2>
          <p>
            Learn how to setup your own Campsite embed with our
            <a
              href="https://support.campsite.bio/en/articles/6830491-embedding-your-profile-on-your-website"
              target="_blank"
              >support article</a
            >.
          </p>
        </div>
      </div>
    </div>

    <PromoSection
      title="Create your best bio link with Campsite"
      text="Embed your Campsite directly into your website today"
    >
      <Button
        href="https://app.campsite.bio/create-account"
        size="large"
        color="secondary"
        >Get Started</Button
      >
    </PromoSection>
  </article>
</template>

<script>
import defaultOG from '@/assets/default-og';
import TextBanner from '@/components/text-banner';
import PromoSection from '@/components/promo-section';
import Code from '@/components/code';
import loadScript from '@/utils/load-script';
import { Button } from '@campsite-bio/component-lib';

export default {
  head: {
    title: 'Demo - Embedding a Campsite',
    meta: [
      ...defaultOG,
      {
        hid: 'description',
        name: 'description',
        content:
          'Get all the power of Campsite on your own website by embedding your Campsite profile with our powerful embed feature!',
      },
    ],
  },

  data() {
    return {
      cdnHost: this.$config.cdnHost,
    };
  },

  components: {
    TextBanner,
    PromoSection,
    Code,
    Button,
  },

  mounted() {
    loadScript(`${this.cdnHost}/js/iframe.js`);
  },
};
</script>

<style lang="scss" scoped></style>
